import React from 'react';
import ReactDOM from 'react-dom';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { Provider } from "react-redux";
import store from "./redux/redux";
import App from './redux/containers/basic';
import './index.scss';
import './index.css';

let Store = store()

const Show = (state) => {
    ReactDOM.render(
            <Provider store={state}>
                <App />
            </Provider>
        , document.getElementById('root')
    );
}

Show(Store);
